// 注意: 梳理发现，此文件线上被引用，但rainbow无此文件，该文件本地不可删除!!

// 根据key动态获取配置文件信息
export const getConfig = (key) => {
  try {
    return require(`portal-common/config/${key}.js`);
  } catch (err) {
    console.error('getConfig', err);
  }
};
